<template>
	<div :class="{'container-fluid':!jobId && !serviceId}">
		<toolbar v-if="!jobId && !serviceId">
			<h2><i class="fa fa-map-pin"></i> Locates</h2>

			<div class="controls">
				<button class="btn btn-success" v-on:click="newTicket">
					<i class="fa fa-plus"></i>
					New Ticket
				</button>
			</div>
		</toolbar>

		<collapsible-panel
			:external-toggle="filterPanelVisible"
			panel-size="md"
			v-on:panelRetract="filterPanelVisible = false">

			<template slot="panel">
				<h3>Filtering</h3>

				<template v-if="!jobId && !serviceId">
					<job-picker
						v-if="filterValues.service_id == 0 || filterValues.service_id == 'null' || !filterValues.service_id"
						col-class="stacked"
						job-type="project"
						key="project"
						v-model="filterValues.job_id"
						v-on:change="jobChange">
					</job-picker>

					<job-picker
						v-if="filterValues.job_id == 0 || filterValues.job_id == 'null' || !filterValues.job_id"
						col-class="stacked"
						job-type="service"
						key="service"
						v-model="filterValues.service_id"
						v-on:change="jobChange">
					</job-picker>
				</template>

				<field label="Action"
					col-class="stacked"
					:params="{type:'select',options:actionOptions}"
					v-model="filterValues.action">
				</field>

				<field label="Status"
					col-class="stacked"
					:params="{type:'select',options:statusOptions}"
					v-model="filterValues.status">
				</field>

				<field label="Ticket #"
					col-class="stacked"
					v-model="filterValues.ticket_num">
				</field>

				<field label="By Date Type" col-class="stacked"
					 :params="{type:'select',options:[
						{text: 'Work to Begin',value:'work_begin_date'},
						{text: 'Date Pulled',value:'date_pulled'},
						{text: 'Expiry Date',value:'expiry_date'},
						{text: 'Refresh Date',value:'refresh_date'},
					]}"
					 v-model="filterValues.dateFilterField">
				</field>

				<form-group v-if="filterValues.dateFilterField" label="Date Range" col-class="stacked">
					<div class="d-flex flex-row">
						<field
							:params="{type:'date'}"
							v-model="filterValues.dateFrom">
						</field>
						<field
							:params="{type:'date'}"
							v-model="filterValues.dateTo">
						</field>
					</div>
				</form-group>

				<field label="Customer"
					col-class="stacked"
					:params="{type:'select',options:$store.customerOptions}"
					v-model="filterValues.customer_id">
				</field>

				<field label="User with a role on job"
					col-class="stacked"
					:params="{type:'select',options:usersWithRoleOptions}"
					v-model="filterValues.user_id">
				</field>

				<field label="Include archived"
					col-class="stacked"
					v-model="filterValues.archived"
					:params="{type:'boolean'}"
					v-on:change="toggleArchivedFilter">
				</field>

				<div class="d-flex mt-1">
					<button class="btn btn-secondary mr-2" v-on:click="clearFilters">
						<i class="fa fa-ban"></i>
						CLEAR
					</button>
					<button class="btn btn-primary" v-on:click="fetchTickets">Filter</button>
				</div>


			</template>
			<template slot="main">

				<h2>
					Locates<br>
					<small v-if="jobId">Project #{{$store.project.job_num}}: {{$store.project.job_name}}</small>
					<small v-else-if="serviceId">Service #{{$store.service.job_num}}: {{$store.service.Customer.name}}</small>
				</h2>

				<table-list record-name="Locate Ticket"
					:fields="ticketFields"
					:records="tickets"
					:sortable="true"
					:has-edit="true"
					:clickable-row="true"
					v-on:edit="openLocateTicket">

					<button class="btn btn-light mr-2"
							  :disabled="filterPanelVisible"
							  v-on:click="openFilterPanel">
						<i class="fa fa-filter"></i>
						Filter
					</button>

					<button v-if="serviceId || jobId" class="btn btn-success" v-on:click="newTicket">
						<i class="fa fa-plus"></i>
						New Ticket
					</button>

					<a :href="downloadZipUrl" class="btn btn-light" :class="{disabled: tickets.length == 0}">
						<i class="fa fa-download"></i>
						Download Zip of Results
					</a>

				</table-list>

			</template>
		</collapsible-panel>

		<modal-dialog :modal-visible="ticketModal.visible"
			:submit-visible="false"
			cancel-button-text="Close"
			:title="ticketModal.title"
			modal-size="modal-lg"
			v-on:closeModal="closeTicketModal">

			<alert
				:visible="'archived' in ticketModal.ticket && ticketModal.ticket.archived == 1"
				:unclosable="true"
				icon="fa-archive"
				classes="alert-warning">
				This locate group is archived.
				<a href="#" v-on:click.prevent="toggleArchivePackage(0)">
					Un-archive
				</a>
			</alert>

			<table-list
				:fields="locateFields"
				:records="ticketModal.ticket.Locate"
				record-name="Locate"
				:has-edit="true"
				:sortable="true"
				:hide-record-count="true"
				v-on:edit="editLocate"
				:has-delete="true"
				delete-endpoint="Locate/delete">

				<div class="d-flex flex-wrap justify-content-end align-items-center">

					<a v-if="'hasDocuments' in ticketModal.ticket && ticketModal.ticket.hasDocuments" class="btn btn-light mr-3" :href="ticketModal.ticket.documentsUrl" target='_blank'>
						View All Documents
					</a>

					<button class="btn btn-light mr-3" v-on:click="editTicket(ticketModal.ticket)">
						Edit Ticket
					</button>

					<button class="btn btn-success" v-on:click="newLocateInTicket">
						<i class="fa fa-plus"></i>
						New Locate
					</button>
				</div>

			</table-list>

		</modal-dialog>


		<!---- TICKET MODEL ---->
		<modal-dialog :modal-visible="editTicketModal.visible"
			:title="editTicketModal.title"
			confirm-button-text="Save"
			:working="editTicketModal.working"
			v-on:closeModal="editTicketModal.visible = false"
			v-on:confirm="saveLocateTicket">

			<field label="Ticket #"
					 col-class="col-md-4"
					 v-model="editTicketModal.payload.ticket_num">
			</field>

			<field v-if="'id' in editTicketModal.payload"
				label="Action"
				col-class="col-md-4"
				:params="{type:'select',options: actionOptions}"
				v-model="editTicketModal.payload.action">
			</field>

			<field label="Address"
					 col-class="col-md-4"
					 v-model="editTicketModal.payload.address">
			</field>

			<field label="Date Pulled"
					 col-class="col-md-4"
					 :params="{type:'date'}"
					 v-model="editTicketModal.payload.date_pulled">
			</field>

			<field label="Work Begin Date"
					 col-class="col-md-4"
					 :params="{type:'date'}"
					 v-model="editTicketModal.payload.work_begin_date">
			</field>

			<template v-if="!jobId && !serviceId">
				<job-picker
					v-if="editTicketModal.payload.service_id == 0 || editTicketModal.payload.service_id == 'null' || !editTicketModal.payload.service_id"
					col-class="col-md-4"
					job-type="project"
					key="project"
					v-model="editTicketModal.payload.job_id"
					v-on:change="jobChange">
				</job-picker>

				<job-picker
					v-if="editTicketModal.payload.job_id == 0 || editTicketModal.payload.job_id == 'null' || !editTicketModal.payload.job_id"
					col-class="col-md-4"
					job-type="service"
					key="service"
					v-model="editTicketModal.payload.service_id"
					v-on:change="jobChange">
				</job-picker>

				<field  v-if="'id' in editTicketModal.payload"
					label="Is Archived?"
					col-class="col-md-4"
					:params="{type:'boolean'}"
					v-model="editTicketModal.payload.archived">
				</field>

			</template>

		</modal-dialog>


		<!---- LOCATE MODEL ---->
		<modal-dialog :modal-visible="editLocateModal.visible"
			:title="editLocateModal.title"
			:working="editLocateModal.working"
			confirm-button-text="Save"
			v-on:closeModal="editLocateModal.visible = false"
			v-on:confirm="saveLocate">

			<field label="Utility"
				col-class="col-md-4"
				v-model="editLocateModal.payload.utility"
				:params="{type:'text',placeholder:'Hydro, gas, etc'}">
			</field>

			<field label="Status"
				col-class="col-md-4"
				:params="{type:'select',options:statusOptions}"
				v-model="editLocateModal.payload.status">
			</field>

			<field label="Expiry Date"
				col-class="col-md-4"
				v-if="!editLocateModal.isTicket"
				:params="{type:'date'}"
				v-model="editLocateModal.payload.expiry_date">
			</field>

			<field label="Refresh Date"
				col-class="col-md-4"
				v-if="!editLocateModal.isTicket"
				:params="{type:'date'}"
				v-model="editLocateModal.payload.refresh_date">
			</field>

			<form-group
				label="Locate Document" col-class="col-md-4">

				<field v-if="editLocateModal.filename"
						 :readonly="true"
						 v-model="editLocateModal.filename">
				</field>

				<image-panel v-if="editLocateModalDocUrl"
					:image-url="editLocateModalDocUrl"
					:expand-url="editLocateModalDocUrl"
					:expand-on-click="true"
					v-on:deleteImg="deleteFile">
				</image-panel>

				<upload-field v-else
					style="width:100%;height: 40px;margin-top:10px"
					:icons="['fa-plus','fa-file']"
					accept="documents/images"
					target="UploadFile/save"
					style-type="box"
					v-on:uploaded="fileUploaded">
				</upload-field>
			</form-group>

		</modal-dialog>
	</div>
</template>
<script type="text/javascript">
import Toolbar from "@/layout_fragments/Toolbar"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"
import UploadField from "@/components/UploadField"
import FormGroup from "@/components/FormGroup"
import ImagePanel from "@/components/ImagePanel"
import CollapsiblePanel from "@/layout_fragments/CollapsiblePanel"
import Alert from "@/components/Alert"
import PdfJs from "@/components/PdfJs"
import JobPicker from "@/components/super_components/JobPicker"

import JobMixins from "@/mixins/JobMixins"


export default {
	name: "Locates",
	components: {
		Toolbar,
		TableList,
		ModalDialog,
		Field,
		UploadField,
		FormGroup,
		ImagePanel,
		CollapsiblePanel,
		Alert,
		PdfJs,
		JobPicker
	},
	mixins: [JobMixins],
	props: [
		"jobId",
		"serviceId",
		"hasJobId" //flag to signify holding off on the fetch if jobId or serviceId prop is incoming (otherwise the whole list will be pulled when it shouldn't be)
	],
	data() {
		return {
			//locates: [],
			//locateTickets: [],		// We fetch this too and use it as a reference for ticket Actions
			tickets: [],

			filterPanelVisible:false,

			filterValues: {
				job_id: null,
				service_id: null,
				dateFilterField: null,
				dateFrom: null,
				dateTo: null,
				status: null,
				ticket_num: null,
				archived: 0,
				user_id: null //special handling: client side filter for tickets with jobs with this user role on it
			},

			// CREATING or EDITING a locate
			editLocateModal: {
				visible: false,
				working: false,
				title: "",
				filename: "",
				UploadFile: {},
				locate: {},			// We keep a ref. to the locate so we can update with payload after saving
				payload: {}			// We keep a payload to update during editing
			},

			// VIEWING a ticket and its locates
			ticketModal: {
				visible: false,
				ticket: {},
			},

			// CREATING or EDITING a ticket
			editTicketModal: {
				visible: false,
				working: false,
				payload: {},
				title: ""

			},

			projectFields: ["id","slug","job_name","job_num","customer_id","User","deleted","is_lead","archived","date_completed","JobBid"],
			serviceFields: ["id","slug","job_name","job_num","customer_id","User","status"],

			statusOptions: [
				{text: 'READY',       value:'READY'},
				{text: 'IN PROGRESS', value:'IN PROGRESS'},
				{text: 'OVERDUE',     value:'OVERDUE'}
			],

			actionOptions: [
				{text: 'REFRESH',     value: 'Refresh'},
				{text: 'HOLD',        value: 'Hold'},
				{text: 'CLOSE',       value: 'Close'},
			],

			// Should we open the ticket modal after the next fetch?
			openModal: false,

		}
	},
	watch: {
		jobId() {
			this.fetchTickets()
		},
		serviceId() {
			this.fetchTickets()
		}
	},
	computed: {

		ticketPayload() {
			return {
				filters: [],
				include: [
					{
						model: "Locate",
						include: [ "UploadFile" ]
					},
					{
						model: "Job",
						fields: this.projectFields,
						include: [
							{ model:"User",fields:["id","slug","first_name","last_name"] },
							{ model:"JobBid",fields:["is_active","status"]}
						]
					},
					{
						model: "Service",
						fields: this.serviceFields,
						include: [{ model:"User",fields:["id","slug","first_name","last_name"] }]
					}
				],
				orders: [
					["work_begin_date", "DESC"]
				]
			}
		},

		locateFields() {
			let fields = [
				{label: "Utility",key:"utility"},
				{label: "Status",key:'fullStatus'},
				//{label: "Date Pulled",key:"date_pulled"},
				{label: "Expiry Date",key:"expiry_date"},
				{label: "Refresh Date",key:"refresh_date"},
				{label: "Document",key:"documentLinkTag"}
			]

			return fields
		},

		ticketFields() {
			let fields = [
				{label: "Ticket #",key:"ticket_num"},
				{label: "Address",key:"address"},
				{label: "Status",key:'fullStatus'},
				{label: "Action",key:'fullAction',align:'center'},
				{label: "Date Pulled",key:"date_pulled"},
				{label: "Work to Begin Date",key:"work_begin_date"},
				{label: "Expiry Date",key:"fullExpiryDate"},
				{label: "Refresh Date",key:"refreshDate"},
				{label: "Project/Service",key:"jobName"},
				{label: "Project/Service Status",key:"jobStatus"},
				{label: "No. of Locates",key:"numLocates", align:"center"},
			]

			if (this.filterValues.archived)
				fields.push({label: "Archived",key:"fullArchived", align:"center"})

			if (this.jobId || this.serviceId)
				fields.splice(4,1)

			return fields
		},
		editLocateModalDocUrl() {
			if ("UploadFile" in this.editLocateModal && this.editLocateModal.UploadFile) {
				return window.apiRoot+"resources/files/"+this.$store.sessionToken+"/"+this.editLocateModal.UploadFile.filename+"?display=true"
			}
			return ""
		},
		usersWithRoleOptions() {
			//go through all locate jobs and compile a list of users

			let users = []
			this.tickets.forEach(ticket => {

				let job
				if (ticket.Job)
					job = ticket.Job
				else if (ticket.Service)
					job = ticket.Service

				if (job) {

					job.User.forEach(user => {
						let userInList = users.find(listUser => listUser.id == user.id)

						if (!userInList)
							users.push(user)
					})
				}
			})

			return this.optionify(users.map(user => {
				user.fullName = user.first_name+" "+user.last_name
				return user
			}),"fullName").sort((a,b) => {
				return a.text > b.text ? 1 : -1
			})
		},

		ticketFilters() {
			let filters = []

			if (this.jobId)
				filters.push(["job_id",this.jobId])
			if (this.serviceId)
				filters.push(["service_id",this.serviceId])

			if (this.filterValues.job_id)
				filters.push(["job_id",this.filterValues.job_id])
			if (this.filterValues.service_id)
				filters.push(["service_id",this.filterValues.service_id])

			if (this.filterValues.action) {
				filters.push(["action",this.filterValues.action])
			}

			if (this.filterValues.ticket_num)
				filters.push(["ticket_num",this.filterValues.ticket_num])

			let dff = this.filterValues.dateFilterField
			if (dff) {

				// Ticket filters
				if (['date_pulled', 'work_begin_date'].includes(dff)) {
					if (this.filterValues.dateFrom)
						filters.push([dff+" >=", this.filterValues.dateFrom])
					if (this.filterValues.dateTo)
						filters.push([dff+" <=",this.filterValues.dateTo])
				}

				// Locate filters (date_pulled is a ticket filter)
				if (['expiry_date', 'refresh_date'].includes(dff)) {
					if (this.filterValues.dateFrom)
						filters.push(["Locate."+dff+" >=", this.filterValues.dateFrom,"and","datetime"])
					//if (this.filterValues.dateTo)
					//	filters.push(["Locate."+dff+" <=",this.filterValues.dateTo,"and","datetime"])
				}

			}

			if (!this.filterValues.archived)
				filters.push(["archived",0])

			// Cannot be expired
			if (this.filterValues.status) {

				if (this.filterValues.status == 'READY') {
					filters.push(["Locate.status","READY", "and", false, "match-all"])
				} else if (this.filterValues.status == 'IN PROGRESS') {
					filters.push(["Locate.status", 'IN PROGRESS', "and"])
					//filters.push(["Locate.expiry_date >",this.moment().format("YYYY-MM-DD"),'and','datetime','match-all'])

				} else if (this.filterValues.status == 'OVERDUE') {
					filters.push(["Locate.status", 'OVERDUE'])
				}
			}

			if (this.filterValues.customer_id)
				filters.push(["Job.customer_id",this.filterValues.customer_id])

			return filters
		},
		downloadZipUrl() {
			let baseUrl = window.apiBase+"LocateTicket/zip-package"

			let queryString = "?token="+this.$store.sessionToken+"&filters="+JSON.stringify(this.ticketFilters)
			return baseUrl+queryString
		}
	},
	methods: {

		clearFilters() {

			this.filterValues.job_id = null
			this.filterValues.service_id = null
			this.filterValues.dateFilterField = null
			this.filterValues.dateFrom = null
			this.filterValues.dateTo = null
			this.filterValues.status = null
			this.filterValues.ticket_num = null
			this.filterValues.archived = 0
			this.filterValues.user_id = null
			this.filterValues.customer_id = null
			this.filterValues.action = null

			this.fetchTickets()
		},

		toggleArchivedFilter(isArchived) {
			this.filterValues.archived = isArchived
			this.fetchTickets()
		},

		mutateTickets(tickets) {
			let vm = this

			this.tickets = tickets.map(ticket => {

				let jobName = ""

				if ("Job" in ticket && ticket.Job)
					jobName = "Project #"+ticket.Job.job_num+" "+ticket.Job.job_name
				else if ("Service" in ticket && ticket.Service)
					jobName = "Service #"+ticket.Service.job_num+" "+ticket.Service.job_name

				if (jobName.length > 30)
					jobName = jobName.substr(0,30)+"..."

				ticket.jobName = jobName


				let jobStatus = ""

				if ("Job" in ticket && ticket.Job)
					jobStatus = this.getJobStatus(ticket.Job)
				else if ("Service" in ticket && ticket.Service && 'status' in ticket.Service && ticket.Service.status)
					jobStatus = ticket.Service.status

				if (jobStatus.length > 30)
					jobStatus = jobName.substr(0,30)+"..."

				ticket.jobStatus = jobStatus


				let archived = ""
				let rowClasses = ""
				if (ticket.archived == 1) {
					archived = "<span class='fa fa-archive'></span>"
					rowClasses = "bg-light text-muted"
				}
				ticket.fullArchived = archived
				ticket.rowClasses = rowClasses

				ticket.documentsUrl = window.apiRoot+"resources/tickets/"+this.$store.sessionToken+"/"+ticket.slug

				let ticketExpiryDate = "", ticketRefreshDate = "", ticketDatePulled = ""
				let ticketStatus = "READY"
				let ticketHasDocuments = false

				ticket.Locate.map(locate => {

					if (locate.expiry_date && (!ticketExpiryDate || locate.expiry_date < ticketExpiryDate))
						ticketExpiryDate = locate.expiry_date

					if (locate.refresh_date && (!ticketRefreshDate || locate.refresh_date < ticketRefreshDate))
						ticketRefreshDate = locate.refresh_date

					//if (locate.date_pulled && (!ticketDatePulled || locate.date_pulled < ticketDatePulled))
					//	ticketDatePulled = locate.date_pulled

					// Set ticket status
					if (locate.status == "IN PROGRESS" && ticketStatus != "OVERDUE")
						ticketStatus = "IN PROGRESS"
					else if (locate.status == "OVERDUE")
						ticketStatus = "OVERDUE"

					// Now do mutate locate
					locate.documentLinkTag = ""
					locate.documentUrl = ""
					if ("UploadFile" in locate && locate.UploadFile) {
						locate.documentUrl = window.apiRoot+"resources/files/"+this.$store.sessionToken+"/"+locate.UploadFile.filename+"?display=true"
						locate.documentLinkTag = "<a href='"+locate.documentUrl+"' target='_blank'>View Document</a>"
						ticketHasDocuments = true
					}

					let statusClass = ""
					if (locate.status == "READY")
						statusClass = "text-success"

					let status = locate.status
					if (status === true)
						status = ""

					if (vm.moment.utc(locate.expiry_date).isBefore(vm.moment())) {
						statusClass = "text-danger"
						status = "EXPIRED"
						locate.status = status
					}

					locate.fullStatus = "<span class='"+statusClass+"'>"+status+"</span>"

					return locate

				}).sort((a,b) => {
					if (vm.moment(a.expiry_date).isAfter(b.expiry_date))
						return 1
					else
						return -1
				})

				if (vm.moment.utc(ticketExpiryDate).isBefore(vm.moment()))
					ticketStatus = "EXPIRED"

				ticket.expiryDate = ticketExpiryDate
				ticket.refreshDate = ticketRefreshDate
				ticket.datePulled = ticketDatePulled
				ticket.status = ticketStatus
				ticket.numLocates = ticket.Locate.length
				ticket.hasDocuments = ticketHasDocuments

				let actionIcon = ""
				let actionColor = ""

				if (ticket.action == 'Refresh') {
					actionIcon = "fa fa-redo-alt"
					actionColor = "text-success"
				} else if (ticket.action == 'Hold') {
					actionIcon = "fa fa-pause-circle"
					actionColor = "text-warning"
				} else if (ticket.action == 'Close') {
					actionIcon = "fa fa-times-circle"
					actionColor = "text-danger"
				}

				ticket.fullAction = "<i class='" + actionIcon + " " + actionColor + "'>"

				if (ticket.status == 'EXPIRED') {
					ticket.fullStatus = "<span class='text-danger'>" + ticket.status + "</span>"
					ticket.fullExpiryDate = "<span class='text-danger'>" + ticket.expiryDate + "</span>"
				} else {
					ticket.fullStatus = ticket.status
					ticket.fullExpiryDate = ticket.expiryDate
				}

				return ticket
			})

		},
		jobChange(value) {
			this.$forceUpdate()
		},
		newTicket() {
			this.editTicketModal.visible = true
			this.editTicketModal.title = "New Locate Ticket"
			this.editTicketModal.payload = {
				ticket_num: ""  // ticket_num MUST be set
			}
		},

		newLocateInTicket() {

			this.editLocateModal.title = "New Locate for Ticket #" + this.ticketModal.ticket.ticket_num

			this.editLocateModal.locate = {
				ticket_num: this.ticketModal.ticket.ticket_num,
				ticket_id: this.ticketModal.ticket.id,
				work_begin_date: this.ticketModal.ticket.work_begin_date,
				job_id: this.ticketModal.ticket.job_id,
				service_id: this.ticketModal.ticket.service_id,
				address: this.ticketModal.ticket.address,
				utility: null,
				expiry_date: null,
				refresh_date: null,
				status: null,
				UploadFile: null
			}

			this.editLocateModal.payload = this.cloneObj(this.editLocateModal.locate)

			this.editLocateModal.filename = ""
			this.editLocateModal.UploadFile = false
			this.editLocateModal.visible = true

			//this.editLocateModal.payload.date_pulled = (this.ticketModal.ticket.Locate.length > 0) ?
			//	this.ticketModal.ticket.Locate[0].date_pulled : ""
		},

		saveLocateTicket() {
			let vm = this

			this.editTicketModal.working = true
			let payload = this.editTicketModal.payload

			if (this.jobId)
				payload.job_id = this.jobId
			else if (this.serviceId)
				payload.service_id = this.serviceId

			let validKeys = ['id', 'ticket_num', 'action', 'address', 'work_begin_date', 'date_pulled', 'job_id', 'service_id', 'archived'];
			Object.keys(payload).forEach((key) => validKeys.includes(key) || delete payload[key]);

			this.postData("LocateTicket/save", payload).then(response => {

				vm.editTicketModal.working = false
				let ticketIndex = vm.tickets.findIndex(t => t.id == payload.id)

				let params = {
					include: vm.ticketPayload.include
				}

				// Refetch and move on
				vm.getJSON("LocateTicket/find/"+response.data.record_id, params).then(ticketResponse => {

					let newTicket = ticketResponse.data

					if (ticketIndex != -1)
						vm.tickets[ticketIndex] = newTicket
					else
						vm.tickets.unshift(newTicket)

					vm.mutateTickets(vm.tickets)
					vm.openLocateTicket(newTicket)
				})

				// Close the ticket edit modal
				vm.editTicketModal.visible = false
			})
		},

		editTicket(ticket) {
			this.editTicketModal.visible = true
			this.editTicketModal.title = "Edit Ticket #" + ticket.ticket_num
			this.editTicketModal.payload = this.cloneObj(ticket)
		},

		editLocate(locate) {
			this.editLocateModal.title = "Edit Locate"
			this.editLocateModal.locate = locate
			this.editLocateModal.payload = this.cloneObj(locate)
			this.editLocateModal.UploadFile = this.cloneObj(this.editLocateModal.payload.UploadFile)

			if (this.editLocateModal.payload.UploadFile)
				this.editLocateModal.filename = this.editLocateModal.payload.UploadFile.original_filename
			else
				this.editLocateModal.filename = null

			this.editLocateModal.visible = true
		},

		openLocateTicket(ticket) {
			window.history.pushState({},"","/locates/"+ticket.ticket_num)
			this.ticketModal.visible = true
			this.ticketModal.ticket = ticket
			this.ticketModal.title = "Locates for Ticket #"+ticket.ticket_num
		},

		fileUploaded(response) {
			this.editLocateModal.payload.file_id = response.data.id
			this.editLocateModal.filename = response.data.original_filename
			this.editLocateModal.UploadFile = {
				id: response.data.id,
				filename: response.data.filename,
				original_filename: response.data.original_filename
			}
		},

		deleteFile() {
			let vm = this

			this.postData("UploadFile/delete",{id:vm.editLocateModal.UploadFile.id}).then(response => {
				if (response.success) {
					vm.editLocateModal.UploadFile = null
					vm.postData("Locate/save",{id: vm.editLocateModal.payload.id,file_id:0}).then(responseLocate => {
						vm.editLocateModal.payload.file_id = 0
					})
				}
			})
		},

		closeTicketModal() {
			window.history.pushState({},"","/locates/")
			this.ticketModal.visible = false
		},

		openFilterPanel() {
			this.filterPanelVisible = true
			let vm = this
			let promises = []
			if (this.$store.customerOptions.length == 0)
				promises.push(this.fetchCustomers())

			if (this.$store.projects.length == 0)
				promises.push(this.fetchJobs([],[],this.projectFields))

			this.spinner(true)

			Promise.all(promises).then(response => {
				vm.spinner(false)
			})
		},

		saveLocate() {
			let vm = this

			this.editLocateModal.working = true

			let payload = vm.cloneObj(this.editLocateModal.payload)

			if (this.jobId)
				payload.job_id = this.jobId
			else if (this.serviceId)
				payload.service_id = this.serviceId

			let validKeys = ['id', 'utility', 'status', 'expiry_date', 'refresh_date', 'file_id', 'ticket_id'];
			Object.keys(payload).forEach((key) => validKeys.includes(key) || delete payload[key]);

			this.postData("Locate/save",payload,true).then(response => {
				vm.editLocateModal.working = false

				if (response.success) {
					vm.editLocateModal.visible = false

					// Get new locate info
					vm.getJSON("Locate/find/"+response.data.record_id, {include: [ "UploadFile" ]}).then(locateResponse => {

						if (locateResponse.success) {

							// Update locate
							Object.keys(vm.editLocateModal.locate).forEach(key => {
								if (key in locateResponse.data)
									vm.editLocateModal.locate[key] = locateResponse.data[key]
							})

							// Add locate to ticket if it is new
							if (!('id' in payload)) {
								vm.editLocateModal.locate.id = locateResponse.data.id
								vm.editLocateModal.locate.slug = locateResponse.data.slug
								vm.ticketModal.ticket.Locate.push(vm.editLocateModal.locate)
							}

							vm.mutateTickets(vm.tickets)
						}
					})


				}
			})
		},
		toggleArchivePackage(archiveState) {

			this.editTicketModal.payload = {
				id: this.ticketModal.ticket.id,
				archived: archiveState
			}

			this.saveLocateTicket()
		},

		fetchTickets() {
			let vm = this

			let params = this.cloneObj(this.ticketPayload)

			// Add in our ticket filters
			params.filters = params.filters.concat(this.ticketFilters);

			vm.spinner(true)

			vm.getJSON("LocateTicket/get", params, true).then(response => {

				vm.spinner(false)

				vm.tickets = response.data

				// Filter by user_id if filter value is provided
				if (vm.filterValues.user_id > 0) {

					// Only include tickets with 1+ matching locates
					vm.tickets = vm.tickets.filter(ticket => {

						let job
						if (ticket.Job)
							job = ticket.Job
						else if (ticket.Service)
							job = ticket.Service

						if (job) {
							let hasMatchingRole = job.User.find(user => user.id == vm.filterValues.user_id)

							if (hasMatchingRole)
								return true
						}

						return false

					})
				}

				// filter by date range if provided
				if (this.filterValues.dateFrom && this.filterValues.dateTo) {
					vm.tickets = vm.tickets.filter(ticket => {

						let hasLocateInRange = ticket.Locate.find(locate => vm.moment(locate[vm.filterValues.dateFilterField]).isAfter(vm.moment(vm.filterValues.dateFrom)) && vm.moment(locate[vm.filterValues.dateFilterField]).isBefore(vm.moment(vm.filterValues.dateTo)))

						if (hasLocateInRange)
							return true

						return false
					})
				}

				vm.editLocateModal.payload = {}

				// OpenModal? Open Ticket Modal
				if (vm.openModal) {
					let ticket = vm.tickets.find(ticket => {
						return ticket.ticket_num == vm.$route.params.ticket_num
					})
					if (ticket)
						vm.openLocateTicket(ticket)
					vm.openModal = false
				}

				vm.mutateTickets(vm.tickets)
			})

		}
	},
	created() {
		if ('ticket_num' in this.$route.params) {
			this.openModal = true

		}

		if (
			((!this.serviceId || !this.jobId) && !this.hasJobId) ||
			((this.serviceId || this.jobId) && this.hasJobId)
		)
			this.fetchTickets()
	}
}
</script>